import './index.erb';
import './index.rb';
import s from './index.module.scss';
class ComponentGuideFeaturedV2 {
  constructor(container) {
    this.container = container;
    setTimeout(() => {
      this.bind();
    }, 500);
  }

  bind() {
    this.tabs = document.querySelectorAll('.card-tab-item', this.container);
    this.tabcontent = document.querySelectorAll(
      '.card-tab-content',
      this.container
    );
    this.tabCurrentId = 0;
    this.tabCurrentView = null;
    this.tabPreviousView = null;
    this.tabMenuCurrent = null;
    this.tabMenuPrevious = null;

    this.hideContent();
    this.configureTabButtons();
    this.showTab(this.tabCurrentId);
  }

  hideContent() {
    this.tabcontent.forEach(tab => {
      $(tab).hide();
    });
  }

  configureTabButtons() {
    this.tabs.forEach(tab => {
      $(tab).on('click', e => {
        const currentTab = $(e.currentTarget);
        currentTab.addClass(s.cardItemActive);
        this.tabCurrentId = currentTab.attr('data-card-tab');
        this.showTab(this.tabCurrentId);
      });
    });
  }

  selectTabButton(id) {
    if (this.tabMenuPrevious) {
      this.tabMenuPrevious.removeClass(s.cardItemActive);
      this.tabMenuPrevious = null;
    }

    this.tabMenuCurrent = this.getTabMenu(id);
    this.tabMenuCurrent.addClass(s.cardItemActive);

    this.tabMenuPrevious = this.tabMenuCurrent;
  }

  getTab(id) {
    return $(`.card-tab-content[data-card-tab="${id}"]`);
  }

  getTabMenu(id) {
    return $(`.card-tab-item[data-card-tab="${id}"]`);
  }

  showTab(id) {
    if (this.tabPreviousView) {
      this.tabPreviousView.fadeOut();
      this.tabPreviousView = null;
    }

    this.selectTabButton(id);

    this.tabCurrentView = this.getTab(id);
    this.tabCurrentView.delay(250).fadeIn();

    this.tabPreviousView = this.tabCurrentView;
  }
}

(() => {
  new ComponentGuideFeaturedV2('#component-guide-featured-v2');
})();
